import {
  SUCCESS_MESSAGE,
  TOGGLE_MODAL,
  START_MODAL_FADE,
  SET_MODAL,
  SET_PLAN_MODAL,
  TOGGLE_PLAN_MODAL,
  RESET_SUCCESS_MESSAGE
} from './types';

export const toggleModal = ({show, type}) => {
  return {
    type: TOGGLE_MODAL,
    payload: {show, type}
  };
};

export const startFadeOut = () => {
  return {
    type: START_MODAL_FADE
  };
};

export const setModal = ({title, description, icon, onPress, submit, onCancel, cancel, buttonType}) => {
  return {
    type: SET_MODAL,
    payload: {title, description, icon, onPress, submit, cancel, onCancel, buttonType}
  };
};

export const setPlanModal = ({ plan }) => {
  return {
    type: SET_PLAN_MODAL,
    payload: { plan }
  };
};

export const togglePlanModal = (toggle) => {
  return {
    type: TOGGLE_PLAN_MODAL,
    payload: toggle
  };
};

export const resetSuccessMessage = () => {
  return {
    type: RESET_SUCCESS_MESSAGE
  };
};

export const showSuccess = (success_message) => {
  return {
    type: SUCCESS_MESSAGE,
    payload: success_message
  };
}



// WEBPACK FOOTER //
// ./src/actions/ModalActions.js